import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=6465cea0"
import script from "./EmployeeSearch.vue?vue&type=script&lang=js"
export * from "./EmployeeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports